import React, { useState, useCallback } from 'react';
import { useLocation, useHistory } from 'react-router-dom';
import { cloneDeep } from 'lodash-es';

export function useQuery() {
  const history = useHistory();
  const location = useLocation();

  // init query from location 
  const [ query, setQuery ] = useState(
    Object.fromEntries(new URLSearchParams(location.search).entries()));

  const updateQuery = useCallback(q => {
    console.log(q)
    const newQuery = Object.assign(cloneDeep(query), q);
    const newParams = new URLSearchParams(newQuery);
    history.push({ search: newParams.toString() });
    setQuery(Object.fromEntries(newParams.entries()));
  }, [ history ]);

  return {
    query,
    updateQuery
  };
}